/**
 * 关键字高亮
 * 在引用得页面 定义 keywordHighlight 样式
 * @param str
 * @param key
 * @returns {*}
 */
export const keywordHighlight = (str, key) => {
  if (!key) {
    return str
  }
  return str.replace(new RegExp(key, 'g'), `<span class="keywordHighlight">${key}</span>`)
}

/**
 * 关键字高亮
 * 在引用得页面 定义 keywordHighlight 样式
 * @param str
 * @param key
 * @returns {*}
 */
export const textSlice = (str, length) => {
  if (!str) return
  str = str.toString()
  if (str.length > length) return str.substring(0, length) + '...'
  else return str
}

/**
 *
 * @param date
 * @returns {string}
 */
export const dateFormat = (date, format) => {
  if (!date) {
    return ''
  }
  let d = new Date(date)
  let o = {
    'y+': d.getFullYear(),
    'M+': d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : '' + (d.getMonth() + 1),
    'd+': d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate(),
    'h+': d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours(),
    'm+': d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes(),
    's+': d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(format)) {
      let str = o[k] + ''
      format = format.replace(RegExp.$1, str)
    }
  }
  return format
}

/**
 * 12000 => 1.2万
 * @param num
 * @returns {*}
 */
export const myriabit = (num) => {
  if (!num) {
    return 0
  }
  if (num < 10000) {
    return num
  }
  return `${Math.floor((num / 10000) * 10) / 10}万`
}

/**
 * 处理图片地址
 * @param fileName
 * @param size
 * @returns {*}
 */
export const getImageUrl = (fileName, size) => {
  if (!fileName) {
    return ''
  }
  fileName = fileName.replace(/\\/g, '/')
  if (fileName.startsWith('//')) {
    return fileName
  }
  if (fileName.startsWith('http://')) {
    return fileName.substring(5)
  }
  if (fileName.startsWith('https://')) {
    return fileName
  }
  fileName = fileName.startsWith('/') ? fileName : '/' + fileName
  let imageUrl = ''
  if (fileName.indexOf('pic1') > 0) {
    imageUrl = process.env.IMAGE_URL
  } else if (fileName.indexOf('pic2') > 0) {
    imageUrl = process.env.IMAGE_URL2
  } else {
    imageUrl = process.env.IMAGE_URL
    size = 'o'
  }
  return imageUrl + fileName
}

/**
 * 地址协议转换为https
 * @param url
 * @returns {*}
 */
export const replaceTCP = (url) => {
  if (!url) {
    return ''
  }
  if (url.indexOf('https:') > 0) {
    return url
  }
  if (url.indexOf('http:') > 0) {
    return url.replace('http:', 'https:')
  }
  return `https:${url}`
}



// WEBPACK FOOTER //
// ./src/filters/commonFilters.js